import { SideStatisticsItemProps } from '@ahc-digital/component-library';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { C51SideStatisticsItemProps } from './C51SideStatisticsItem.types';

export function CreateSideStatisticsItemModel(
  props?: C51SideStatisticsItemProps
): SideStatisticsItemProps {
  const { fields } = props || {};

  const { renderText, renderRichText } = useConditionalRendering();

  return {
    prefix: renderText(fields?.Prefix),
    statistic: renderText(fields?.Statistic, { required: true }),
    suffix: renderText(fields?.Suffix),
    supportCopy: renderRichText(fields?.SupportCopy, { required: true }),
  };
}
